import cn from 'classnames';
import { ChangeEvent, FC } from 'react';

import { ImageSizeType } from '@/shared/config/types';

import { TransformedPhoto } from '@/features/transformedPhoto';

import styles from './DentalPhotoCheckbox.module.scss';

type DentalPhotoCheckboxProps = {
  photoID: string;
  size: ImageSizeType;
  checked: boolean;
  name?: string;
  id?: string;
  required?: boolean;
  boxClassName?: string;
  disabled?: boolean;
  className?: string;
  testID?: string;
  onChange: (event: boolean | ChangeEvent<Element>) => void;
};

export const DentalPhotoCheckbox: FC<DentalPhotoCheckboxProps> = (props) => {
  const {
    photoID,
    size,
    checked,
    className,
    boxClassName,
    testID,
    disabled = false,
    onChange,
    name,
    id,
  } = props;

  return (
    <label
      id={id}
      className={cn(
        styles.container,
        disabled && styles.disabled,
        'p2',
        className,
      )}
      data-testid={testID}
      data-component="dental-photo-select-checkbox"
    >
      <input
        type="checkbox"
        className={styles.input}
        disabled={disabled}
        checked={checked}
        onChange={onChange}
        name={name}
      />

      <div className={cn(styles.checkbox, boxClassName)} />

      <TransformedPhoto
        photoID={photoID}
        size={size}
        alt={name ?? ''}
        className={styles.content}
      />
    </label>
  );
};
